import styled from 'styled-components';
export const BKJHorizontalRule = styled.hr `
  width: 100%;

  ${({ theme, variant }) => theme.hr[variant]};
  border: none;
  margin: 20px 0 30px 0;
`;
//# sourceMappingURL=BKJHorizontalRule.js.map